export const mimetypes = {
 'xlsx':'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
 'xls':'application/vnd.ms-excel',
 'xlsm':'application/vnd.ms-excel.sheet.macroEnabled.12',
 'csv':'text/csv',
 'docx':'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
 'doc':'application/msword',
 'pdf':'application/pdf'
};

export const months_map = {
  "01":"enero",
  "02":"febrero",
  "03":"marzp",
  "04":"abril",
  "05":"mayo",
  "06":"junio",
  "07":"julio",
  "08":"agosto",
  "09":"septiembre",
  "10":"octubre",
  "11":"noviembre",
  "12":"diciembre"
};
export const risk_metric_labels = {vol:"Volatilidad Anual.", "var":"Valor en Riesgo 95%"};
export const ret_metric_labels = {mean:"Retorno Promedio Anual.", median:"Retorno Mediana Anual.", mom:"Retorno MoM (12M)"};

export const colors = ['#000000', "#2f10e0", '#707372', "#42c8f5", "#f5f242", 
                '#9EA2A2', '#C7C9C7', '#768692', '#789F90', '#9AB9AD',
                '#98A4AE', '#A4BCC2', '#B7CDC2',
                '#7A6855', '#A39382', '#B7A99A',
                '#A69F88', '#B7B09C', '#D1CCDB',
                '#BF9474', '#CDA788', '#DCBFA6'];

export const colors_sura = [
    '#000000',"#1215E3", "#FAEA2F", 
    '#9EA2A2','#C7C9C7', '#768692',
    '#0E0E95','#333333', '#E9E9F0',
    "#0A0A6B",
    '#7A6855',
    '#6A0DAD', 
    '#8c8888', '#98A4AE',
    '#494949',"#383AC7", "#9F9204", 
    '#505353','#949994', '#4D5E6B'
];

export const colors_sura_inv = [
    '#24272A','#0B2DCE', "#98A4AE", '#FFE946', "#5A646E", 
    '#C8C8C8','#A3E1C2', '#E0C1A2',
    '#D49A7D','#DE9CA6', '#CBB363',
    '#A0A0A0','#7FD483', '#D5AB80',
    '#C9805C','#9E3541', '#A8CDE2',
    '#727272','#52C599', '#CC9967',
    '#9B5634','#D4BE7F', '#3C86B4'
];


export const assets = [
    {manager:'manager 1', funds:['fund m1f1', 'fund m1f2', 'fund m1f3', 'fund m1f4', 'fund m1f5']},
    {manager:'manager 2', funds:['fund m2f1', 'fund m2f2', 'fund m2f3', 'fund m2f4', 'fund m2f5']},
    {manager:'manager 3', funds:['fund m3f1', 'fund m3f2', 'fund m3f3', 'fund m3f4', 'fund m3f5']},
    {manager:'manager 4', funds:['fund m4f1', 'fund m4f2', 'fund m4f3', 'fund m4f4', 'fund m4f5']},
    {manager:'manager 5', funds:['fund m5f1', 'fund m5f2', 'fund m5f3', 'fund m5f4', 'fund m5f5']}
]


export const avail_files = [{name:'Maestro de activos (asset_data)', bucket:'condor-sura', key:'output/asset_data/asset_data_consol.csv', sep:','},
                            ];

export const suit_files = [{name:"Matrices de máximos", key:"suitability/input/temp/pe/matrixLimitsExposure.csv", arg:"--key_limits", editable:true},
                           {name:"Scores Portafolios", key:"suitability/input/static/pe/port_score.csv", arg:"--key_port_score", editable:false}
                          ];

export const field_options = [
    {var:"AssetClass", label:"Clase de Activo", options:["Money Market", "Renta Fija", "Renta Variable", "Alternativos y Otros", "Real Estate"]},
    {var:"AssetClassMarket", label:"Clase de Activo - Mercado", options:["Renta Fija Local", "Renta Variable Local", "Renta Fija Inter", "Renta Variable Inter"]},
    {var:"Currency", label:"Moneda", options:["USD", "MXN", "COP", "PEN", "CLP", "CLF"]},
    {var:"TipoTasa", label:"Tipo Tasa", options:["Nominal", "Real"]},
    {var:"Sector", label:"Sector", options:["GOB", "CORP"]}
];


export const client_perf_levels = {
    "rentabilidad_consolidada":["clientId"],
    "rentabilidad_platform":["clientId", "marketScope"],
    "rentabilidad_regimen":["clientId","marketScope","contribType"],
    "rentabilidad_entidad":["clientId","marketScope", "contribType","entity"],
    "rentabilidad_producto":["clientId", "marketScope","contribType", "entity", "assetType"],
    "rentabilidad_instrumento":["clientId", "marketScope", "contribType", "entity", "assetType", "assetId", "serie"],
    "rentabilidad_consolidada_regimen":["clientId", "contribType"]
};
